import React from "react";
import "./NeonTextBox.css";

const NeonTextBox = ({ value, onChange, placeholder, inputRef, onFocus, onBlur }) => (
  <input
    ref={inputRef}
    className="neon-textbox"
    type="text"
          value={value}
      onChange={onChange}
      placeholder={placeholder}
      onFocus={onFocus}
      onBlur={onBlur}
      autoFocus
      inputMode="search"
      enterKeyHint="search"
      autoCorrect="off"
      autoCapitalize="none"
      autoComplete="off"
      style={{ outline: "none" }}
  />
);

export default NeonTextBox;
